import React, { useState, useEffect } from "react";
import { Modal, Input, Alert, message } from "antd";
import authApi from "../../../api/authApi";

/**
 * Đổi email hộ thành viên (ADMIN ONLY).
 *
 * Dùng cho ca user mất quyền truy cập email cũ (email công ty cũ, gõ sai domain lúc
 * đăng ký) nên không tự đổi được qua luồng OTP ở app. Trước đây chỉ có ở php admin.
 *
 * Props:
 *   user      - record đang chọn ({ id, name, email }) — null = ẩn modal
 *   onClose   - đóng, không làm gì
 *   onSuccess - gọi sau khi đổi thành công (để refresh danh sách / trang chi tiết)
 */
function UserEmailModal({ user, onClose, onSuccess }) {
    const [newEmail, setNewEmail] = useState("");
    const [loading, setLoading] = useState(false);

    // Reset ô nhập mỗi lần chọn user khác
    useEffect(() => {
        if (user) setNewEmail("");
    }, [user]);

    const handleSubmit = async () => {
        const email = newEmail.trim();
        if (!email) {
            message.error("Vui lòng nhập email mới");
            return;
        }
        setLoading(true);
        try {
            await authApi.changeUserEmail(user.id, email);
            message.success("Đã đổi email thành viên");
            onSuccess();
        } catch (error) {
            message.error(error.response?.data?.message || "Không thể đổi email");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Đổi email thành viên"
            open={Boolean(user)}
            onOk={handleSubmit}
            onCancel={onClose}
            okText="Xác nhận đổi email"
            okButtonProps={{ loading }}
            cancelText="Hủy"
            destroyOnClose
        >
            {user && (
                <div className="flex flex-col gap-4 py-2">
                    <div>
                        <p className="text-xs text-content-3 mb-1">Người dùng</p>
                        <p className="font-semibold">ID {user.id} – {user.name}</p>
                    </div>
                    <div>
                        <p className="text-xs text-content-3 mb-1">Email hiện tại</p>
                        <p className="font-mono text-sm">{user.email}</p>
                    </div>
                    <div>
                        <p className="text-xs text-content-3 mb-1">Email mới</p>
                        <Input
                            value={newEmail}
                            onChange={(e) => setNewEmail(e.target.value)}
                            onPressEnter={handleSubmit}
                            placeholder="nhap@email.moi"
                            autoFocus
                        />
                    </div>
                    {/* Email là danh tính đăng nhập: đổi xong user PHẢI dùng email mới để
                        login/nhận OTP. Cảnh báo để admin khỏi gõ sai rồi khoá user ngoài. */}
                    <Alert
                        type="warning"
                        showIcon
                        message="Sau khi đổi, user đăng nhập và nhận OTP bằng email mới. Thao tác được ghi vào audit log."
                    />
                </div>
            )}
        </Modal>
    );
}

export default UserEmailModal;
